<template>
  <div>
    <account-confirmation></account-confirmation>
    <dashboard-admin v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.ADMIN"></dashboard-admin>
    <dashboard-user v-if=" loggedUser && loggedUser.active && loggedUser.role === UserRoles.APPLICANT"></dashboard-user>
    <dashboard-auditor v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.AUDITOR"></dashboard-auditor>
    <dashboard-regional-admin v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.REGIONAL_ADMIN"></dashboard-regional-admin>
    <dashboard-evaluator v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.EVALUATOR"></dashboard-evaluator>
  </div>
</template>
<script>
  import {UserRoles} from "@/services";
  import DashboardUser from './DashboardUser.vue';
  import DashboardAdmin from './DashboardAdmin.vue';
  import DashboardAuditor from './DashboardAuditor.vue';
  import DashboardRegionalAdmin from './DashboardRegionalAdmin.vue';
  import DashboardEvaluator from './DashboardEvaluator.vue';
  import AccountConfirmation from "./AccountConfirmation.vue";

  export default {
    data() {
      return {
        loggedUser: {},
        UserRoles
      }
    },
    components: {
      AccountConfirmation,
      DashboardUser,
      DashboardAdmin,
      DashboardAuditor,
      DashboardRegionalAdmin,
      DashboardEvaluator,
    },
    beforeMount() {
      this.loggedUser = this.$store.getters['Auth/loggedUser'];
    }
  };
</script>
<style></style>
